import React from 'react';
import {Link} from 'react-router-dom';
import GoogleFontLoader from 'react-google-font-loader';
import 'antd/dist/antd.css';

import './App.css';
import Header from './Header';
import Navigation from './Nav';
import Footer from './Footer';

import { Row, Col, Container,

} from 'reactstrap';

import { FaEnvelope
} from 'react-icons/fa';

function Contact() {


  // Si on veut un formulaire connecter à MongooDB :

  // const [society, setSociety] = useState('')
  // const [email, setEmail] = useState('')
  // const [firstName, setFirstName] = useState('')
  // const [lastName, setLastName] = useState('')
  // const [message, setMessage] = useState('')

  // const { TextArea } = Input

  // const [visible, setVisible] = useState(false)


  // var handleSubmit = async () => {
    
  //   const data = await fetch('http://localhost:3000/sendContact', {
  //     method: 'POST',
  //     headers: {'Content-Type': 'application/x-www-form-urlencoded'},
  //     body: `societyFromFront=${society}&emailFromFront=${email}&firstNameFromFront=${firstName}&lastNameFromFront=${lastName}&messageFromFront=${message}`
   
  //   })

  // }

  // var showModal = () => {
  //   setVisible(true)
  //   handleSubmit()

    

  // }

  // var handleOk = e => {
  //   console.log(e)
  //   setVisible(false)

  //   console.log("society"+society)
    
  // }

  
 
    return(

        <div style={{backgroundColor:'#f5f5f5'}}>
            <Header />
            <Navigation/>

{/* GOOGLE FONTS -------------------------------------------------------------*/}       
<GoogleFontLoader
            fonts={[
              {
                font: 'Roboto',
                weights: [400, '400i'],
              },
              {
                font: 'Roboto Condensed',
                weights: [400, 700],
              },
              {
                  font: 'Titillium Web',
                  weights: [400, 700],
                },
                {
                  font: 'Poppins',
                  weights: [400, 700],
                },
            ]}
            subsets={['cyrillic-ext', 'greek']}
             />

{/* Header ------------------------------------------------------         */}
        <Row>
            <Col className='text-center' style={{ 
                animationName:'example', 
                animationDuration:'20s',
                backgroundColor:'#34b6bc', 
                height:'200px',
                borderBottomRightRadius:'90%',
                borderBottomLeftRadius:'50%'
                }}>
            <h2 style={{marginTop:'50px', color:'black'}}>Contactez-moi</h2>
            <Link to="/" style={{fontSize:'12px', color:'white', 
                                fontWeight:'bold',
                                marginRight:'10px'
                                }}>
             ACCUEIL</Link>
            - BESOIN D'UNE INFORMATION ?
            </Col>
        </Row>

{/* Introduction ---------------------------------------------------         */}
<Container>
    <Col className='text-center' style={{marginTop:'50px', fontFamily:'Poppins', color:'#767676'}}>
        Une question ? Un projet ? N'hésitez pas à m'envoyer un e-mail. 
        Je vous répondrai dans les meilleurs délais et peux me déplacer à Paris et en Île-de-France!
    </Col>
    <Col className='text-center' style={{marginTop:'30px'}}>
    <h2>Caroline Zaini</h2>
    </Col>
    <Col className='text-center'>
      <h3 style={{fontSize:'15px', marginBottom:'50px'}}>
      Paris et Île-de-France</h3>
    </Col>
    <Col className='text-center'><h3 style={{fontSize:'15px',    
                                            fontWeight:'bold', marginBottom:'50px'}}>
      <FaEnvelope 
        size={20} color={'black'} style={{marginRight:'10px'}}/>
                                            zainicaroline@gmail.com</h3>
    </Col>
     
</Container>

{/* Formulaire -----------------------------------------------------        */}
{/* <Container style={{marginTop:'30px', marginBottom:'30px'}}> */}


{/* <div className="Form">
            <Row>
              <Col>  
              <Input onChange={(e) => setSociety(e.target.value)} className="Login-input" placeholder="Société" />
              </Col>
              <Col>  
              <Input onChange={(e) => setEmail(e.target.value)} className="Login-input" placeholder="email" />
               </Col>
            </Row>

            <Row style={{marginTop:'20px'}}>
              <Col>  
              <Input onChange={(e) => setFirstName(e.target.value)} className="Login-input" placeholder="Prénom" />
              </Col>
              <Col>  
              <Input onChange={(e) => setLastName(e.target.value)} className="Login-input" placeholder="Nom" />
               </Col>
            </Row>

            <TextArea rows={4} onChange={(e) => setMessage(e.target.value)} 
            className="Login-input" placeholder="Message" 
                    style={{marginTop:'20px'}}/>
            
   
            <Row>
              <Col className='text-center'>
              
            <Button onClick={() => showModal()}
            
                    style={{marginTop:'20px', marginBottom:'20px',
                    width:'180px',
                    borderColor:'#fc6234',
                    borderWidth:'1px',
                    color:'black',
                    fontSize:'15px',
                    borderRadius:'3.5rem / 100%',
                    fontFamily:'Arial Narrow',
                    letterSpacing:'0.2em',
                    }} 
            >Envoyer
            </Button>
            <Modal  
             footer={[
               <Button key="submit" onClick={() => handleOk()} 
               style={{backgroundColor:'#fc6234', color:'white'}}
               >
      
                 OK</Button>
             ]}
              visible={visible}
              onOk={handleOk}
              closable={false}
            >
              <p>Votre message a bien été envoyé !</p>
              <p>Je vous répondrai dans les plus brefs délais.</p>
              <p>Merci.</p>
            </Modal>
              
          </Col>
        </Row>

      </div> */}

      
     

    {/* </Container> */}
{/* Fin formulaire ------------------------------------------------ */}

            <Footer />
        </div>
    )

}

export default Contact;